import React from "react";
import _ from "lodash";
import { notify } from "react-notify-toast";
import { VseAPI } from "apis";
import UnitState from "../common/UnitState";
import PopupWrapper from "../common/PopupWrapper";
import RecipeBox from "./recipe/RecipeBox";
import ActionPretty from "./recipe/ActionPretty";
import AdUnitBasicCard from "../snapshot/AdUnitBasicCard";
import UnitMode from "../common/UnitMode";
import NumberFormat from "../common/NumberFormat";
import { getUnitStateChangeSummary } from "../../helpers/Pending-Action";
import { UNIT_STATE } from "../../constants/Unit-State";
import VSECheckBox from "./VSECheckbox";
import ReactTooltip from "react-tooltip";
import ModalWrapper from "../common/ModalWrapper";
import VSEPageWrapper from "./VSEPageWrapper";

const PA_STATUS = {
  // TODO: wait for api
  HAS_ACTIONS: "Has Actions",
  NO_ACTIONS: "No Actions",
  HAS_CONFLICTS: "Conflicts",
};

class PendingActionsViewer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      errMsg: null,

      data: null,
      filteredItems: null,

      paStatusFilter: PA_STATUS.HAS_ACTIONS,

      selectedItems: [],
      isModalOpen: false,
      isSaving: false,
      isFixedPopup: false,
      saveErrMsg: null,
    };

    this.handleFilterUnits = this.handleFilterUnits.bind(this);
    this.handleStatusFilterChanged = this.handleStatusFilterChanged.bind(this);

    this.handleSelectAll = this.handleSelectAll.bind(this);
    this.handleSelectItem = this.handleSelectItem.bind(this);
    this.handleClearAll = this.handleClearAll.bind(this);
    this.handleExecuteClicked = this.handleExecuteClicked.bind(this);

    this.handleModalClose = this.handleModalClose.bind(this);
    this.handleConfirmExecute = this.handleConfirmExecute.bind(this);

    this.handleChangePopupFixed = this.handleChangePopupFixed.bind(this);
  }

  async componentDidMount() {
    const networkId = _.get(this.props, "networkId");

    if (networkId) {
      document.title = `PA: ${networkId} | VSE Pending Actions`;
    }

    await this._queryAndUpdateUI({ networkId: _.parseInt(networkId) });
  }

  async _queryAndUpdateUI(params) {
    this.setState({ isLoading: true });
    try {
      const { actions, networkInfo, snapshotsByUnitId } = await this.queryData(
        params
      );
      // console.log(actions);

      if (_.isEmpty(actions)) {
        return this.setState({ errMsg: "No actions found" });
      }

      const unitStateChangeSummary = getUnitStateChangeSummary(actions);

      this.setState({
        data: actions,
        unitStateChangeSummary,
        // filteredItems: actions,
        networkInfo,
        snapshotsByUnitId,
      });

      this.handleStatusFilterChanged(this.state.paStatusFilter);
    } catch (err) {
      console.log("Error querying vse pending actions", err);
    }
    this.setState({ isLoading: false });
  }

  async queryData(params) {
    const { pendingActions, networkInfo, snapshotsByUnitId } =
      await VseAPI.getVSEPendingActionsByNetwork(params);
    const { recipes } = this.props;

    const actions = _.map(pendingActions, (item) => {
      try {
        // item.actions{}
        // proposed_actions[]
        // conflicts[]
        // execution_plan[]

        if (item.actions) {
          // // get recipe name
          item.actions.proposed_actions = _.map(
            item.actions.proposed_actions,
            (action) => {
              const recipe = _.find(recipes, {
                id: action.recipe_id,
                version: action.version,
              });
              action.recipe = recipe || {};
              return action;
            }
          );
        }
      } catch (err) {
        item.actions = null;
        console.log(err);
      }

      return item;
    });
    return { actions, networkInfo, snapshotsByUnitId };
  }

  handleFilterUnits(unitIds) {
    const filteredItems = _.filter(this.state.data, (item) => {
      return _.indexOf(unitIds, item.unit_id) !== -1;
    });
    const paStatusFilter = PA_STATUS.HAS_ACTIONS;
    this.setState({ filteredItems, paStatusFilter });
  }

  handleStatusFilterChanged(paStatusFilter) {
    let filteredItems = [];
    if (paStatusFilter === PA_STATUS.HAS_ACTIONS) {
      filteredItems = _.filter(this.state.data, (item) => {
        return item.actions;
      });
    } else if (paStatusFilter === PA_STATUS.NO_ACTIONS) {
      filteredItems = _.filter(this.state.data, (item) => {
        return !item.actions;
      });
    } else if (paStatusFilter === PA_STATUS.HAS_CONFLICTS) {
      filteredItems = _.filter(this.state.data, (item) => {
        return item.actions && item.actions.conflicts.length > 0;
      });
    }

    this.setState({ paStatusFilter, filteredItems });
  }

  handleSelectAll() {
    const { selectedItems, filteredItems } = this.state;
    if (selectedItems.length === filteredItems.length) {
      this.setState({
        selectedItems: [],
      });
    } else {
      const newSelected = _.map(filteredItems, "unit_id");
      this.setState({ selectedItems: [...selectedItems, ...newSelected] });
    }
  }

  handleSelectItem(unitId) {
    const { selectedItems } = this.state;

    if (_.indexOf(selectedItems, unitId) === -1) {
      this.setState({
        selectedItems: [...selectedItems, unitId],
      });
    } else {
      const newSelectedItems = selectedItems;
      _.pull(newSelectedItems, unitId);
      this.setState({ selectedItems: newSelectedItems });
    }
  }

  handleClearAll() {
    this.setState({ selectedItems: [] });
  }

  handleExecuteClicked() {
    this.setState({ isModalOpen: true });
  }

  handleModalClose() {
    this.setState({ isModalOpen: false });
  }

  async handleConfirmExecute() {
    const params = {
      unitIds: this.state.selectedItems,
    };
    this.setState({ isSaving: true });
    try {
      const { result } = await VseAPI.executeVSEPendingActions(params);
      if (result.op === "ok") {
        notify.show("Execution successful! Reloading page...", "success");
        setTimeout(() => {
          window.location.reload(false);
        }, 3000);
      } else {
        throw `Failed response: ${JSON.stringify(result)}`;
      }
    } catch (err) {
      this.setState({ saveErrMsg: err });
    }
    this.setState({ isSaving: false });
  }

  handleChangePopupFixed(value) {
    this.setState({ isFixedPopup: value });
  }

  render() {
    const {
      isLoading,
      errMsg,
      data,
      filteredItems,
      recipes,
      networkInfo,
      paStatusFilter,
      snapshotsByUnitId,

      unitStateChangeSummary,

      selectedItems,
      isModalOpen,
      isSaving,
      isFixedPopup,
      saveErrMsg,
    } = this.state;

    return (
      <VSEPageWrapper
        isLoading={isLoading}
        errMsg={errMsg}
        networkInfo={networkInfo}
      >
        <div className="mb-4">
          <UnitStateSummary items={data}></UnitStateSummary>
        </div>
        <div className="mb-4">
          <UnitStateChangeSummary
            summary={unitStateChangeSummary}
            handleFilterUnits={this.handleFilterUnits}
          ></UnitStateChangeSummary>
        </div>
        <div className="border mb-2 bg-white px-2 py-2">
          <div className="mb-2 text-sm font-semibold">
            <button
              type="button"
              className={`rounded mr-1 px-2 py-1 font-semibold ${
                paStatusFilter === PA_STATUS.HAS_ACTIONS
                  ? "bg-indigo-200 text-indigo-900"
                  : "bg-gray-100 text-gray-700 hover:bg-gray-200 hover:text-indigo-800"
              }`}
              onClick={() =>
                this.handleStatusFilterChanged(PA_STATUS.HAS_ACTIONS)
              }
            >
              Has actions
            </button>
            <button
              type="button"
              className={`rounded mr-1 px-2 py-1 font-semibold ${
                paStatusFilter === PA_STATUS.NO_ACTIONS
                  ? "bg-indigo-200 text-indigo-900"
                  : "bg-gray-100 text-gray-700 hover:bg-gray-200 hover:text-indigo-800"
              }`}
              onClick={() =>
                this.handleStatusFilterChanged(PA_STATUS.NO_ACTIONS)
              }
            >
              Has no actions
            </button>
            <button
              type="button"
              className={`rounded mr-1 px-2 py-1 font-semibold ${
                paStatusFilter === PA_STATUS.HAS_CONFLICTS
                  ? "bg-indigo-200 text-indigo-900"
                  : "bg-gray-100 text-gray-700 hover:bg-gray-200 hover:text-indigo-800"
              }`}
              onClick={() =>
                this.handleStatusFilterChanged(PA_STATUS.HAS_CONFLICTS)
              }
            >
              Conflicts
            </button>
          </div>
        </div>

        {filteredItems && (
          <div>
            Showing {filteredItems.length} out of {data.length} pending actions
          </div>
        )}

        {data && (
          <div>
            <PendingActionsTable
              networkInfo={networkInfo}
              items={filteredItems}
              snapshotsByUnitId={snapshotsByUnitId}
              recipes={recipes}
              selectedItems={selectedItems}
              handleSelectAll={this.handleSelectAll}
              handleSelectItem={this.handleSelectItem}
              isFixedPopup={isFixedPopup}
              handleOpenModal={() => this.handleChangePopupFixed(true)}
              handleCloseModal={() => this.handleChangePopupFixed(false)}
            ></PendingActionsTable>

            <ActionFooter
              selectedItems={selectedItems}
              handleClearAll={this.handleClearAll}
              handleExecuteClicked={this.handleExecuteClicked}
            ></ActionFooter>

            <ModalWrapper
              isOpen={isModalOpen}
              handleClose={this.handleModalClose}
              width="60%"
              showCloseFooter={false}
              title={`Execute the following units (${selectedItems.length}):`}
            >
              <div>
                <div style={{ height: "500px", overflow: "scroll" }}>
                  <table className="border shadow table w-full text-sm">
                    <thead className="border-b bg-gray-200 text-xs text-blue-800">
                      <tr>
                        <th className="border px-2 py-1">Unit</th>
                        <th className="border px-2 py-1">raw_revenue_ratio</th>
                        <th className="border px-2 py-1">Execution Plan</th>
                        <th className="border px-2 py-1">
                          Proposed by recipes
                        </th>
                        <th className="border px-2 py-1">Updated at</th>
                      </tr>
                    </thead>
                    <tbody className="bg-white font-mono text-gray-900">
                      {selectedItems.map((unitId) => {
                        const r = _.find(data, { unit_id: unitId });
                        return (
                          <tr
                            key={r.unit_id}
                            className="border-b hover:bg-gray-100"
                          >
                            <td className="whitespace-no-wrap border px-2 py-1 font-sans font-semibold">
                              <div className="flex items-center justify-between gap-2">
                                <div>
                                  <PopupWrapper
                                    place="bottom left"
                                    hideArrow={true}
                                    isFixed={isFixedPopup}
                                    triggerElement={
                                      <button
                                        type="button"
                                        className="border-b border-gray-600"
                                      >
                                        {r.unit_id}{" "}
                                        <span className="mr-1 text-gray-700">
                                          {r.unit_name}
                                        </span>
                                        {r.isInsp && (
                                          <span className="rounded bg-orange-400 px-2 text-xs font-bold text-orange-100">
                                            INSP
                                          </span>
                                        )}
                                        {r.isDebug && (
                                          <span className="rounded bg-pink-500 px-2 text-xs font-bold text-pink-100">
                                            DEBUG
                                          </span>
                                        )}
                                        {r.hasGpt && (
                                          <span className="rounded bg-indigo-100 px-2 text-xs text-gray-600">
                                            GPT
                                          </span>
                                        )}
                                        {r.hasAmp && (
                                          <span className="rounded bg-indigo-100 px-2 text-xs text-gray-600">
                                            AMP
                                          </span>
                                        )}
                                      </button>
                                    }
                                    popupElement={
                                      <div
                                        className="overflow-y-auto border-4 border-gray-600 shadow-lg"
                                        style={{
                                          marginTop: "-9px",
                                          maxHeight: "240px",
                                        }}
                                      >
                                        {snapshotsByUnitId[r.unit_id] ? (
                                          <AdUnitBasicCard
                                            networkId={networkInfo.gamNetworkId}
                                            networkName={networkInfo.name}
                                            unit={snapshotsByUnitId[r.unit_id]}
                                            showFullWidthCard={false}
                                            isCompactMode={false}
                                            handleOpenModal={() =>
                                              this.handleChangePopupFixed(true)
                                            }
                                            handleCloseModal={() =>
                                              this.handleChangePopupFixed(false)
                                            }
                                          ></AdUnitBasicCard>
                                        ) : (
                                          <div>No snapshot</div>
                                        )}
                                      </div>
                                    }
                                  ></PopupWrapper>
                                  <UnitMode unit={r}></UnitMode>
                                </div>
                                <div>
                                  <UnitState state={r.unit_state}></UnitState>
                                </div>
                              </div>

                              <div className="text-xs font-normal text-gray-600">
                                {r.ysId} {r.ysName}
                              </div>
                            </td>
                            <td className="whitespace-no-wrap border px-3 py-1 text-left">
                              {r.stat && (
                                <div className="flex flex-row-reverse items-center justify-start gap-2">
                                  <NumberFormat
                                    value={r.stat["raw_revenue_ratio"]}
                                    format="0,0.00%"
                                  ></NumberFormat>
                                  <div className="text-xs font-normal text-gray-600">
                                    <NumberFormat
                                      value={r.stat["raw_eligible_revenue_twd"]}
                                      format="$0,0a"
                                    ></NumberFormat>
                                  </div>
                                </div>
                              )}
                            </td>
                            <td className="whitespace-no-wrap border px-3 py-1 text-left">
                              {r.actions ? (
                                <ul className="list-inside list-disc">
                                  {r.actions.execution_plan.map((ep, i) => {
                                    return (
                                      <li key={i}>
                                        <ActionPretty item={ep}></ActionPretty>
                                      </li>
                                    );
                                  })}
                                </ul>
                              ) : (
                                "No actions"
                              )}
                              {r.actions &&
                                r.actions.conflicts &&
                                r.actions.conflicts.length > 0 && (
                                  <div>
                                    Conflicts:
                                    <div>
                                      {JSON.stringify(r.actions.conflicts)}
                                    </div>
                                  </div>
                                )}
                            </td>
                            <td className="whitespace-no-wrap border px-3 py-1 text-left">
                              {r.actions
                                ? r.actions.proposed_actions.map(
                                    (action, i) => {
                                      return (
                                        <ActionRecipeBox
                                          action={action}
                                          key={i}
                                        ></ActionRecipeBox>
                                      );
                                    }
                                  )
                                : ""}
                            </td>
                            <td className="whitespace-no-wrap border px-3 py-1 text-right">
                              {r.updated_at}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>

                <div className="mt-4 flex flex-row-reverse items-center">
                  <div>
                    <button
                      type="button"
                      className="rounded shadow bg-blue-500 px-4 py-2 font-semibold text-white hover:bg-blue-700"
                      onClick={this.handleConfirmExecute}
                    >
                      {isSaving ? "Saving..." : "Confirm execution"}
                    </button>
                  </div>
                  <div>
                    <button
                      type="button"
                      disabled={isSaving}
                      className={`px-4 py-2 text-blue-700 ${
                        isSaving ? "cursor-not-allowed" : ""
                      }`}
                      onClick={this.handleModalClose}
                    >
                      Cancel
                    </button>
                  </div>
                  <div className="text-red-600">{saveErrMsg}</div>
                </div>
              </div>
            </ModalWrapper>
          </div>
        )}
      </VSEPageWrapper>
    );
  }
}

const UnitStateChangeSummary = (props) => {
  const { summary } = props;
  const summaryKeys = _.sortBy(_.keys(summary));

  return (
    <div>
      <table className="border shadow table w-full text-sm">
        <thead className="border-b bg-gray-200 text-xs text-blue-800">
          <tr>
            <th className="border px-2 py-1">
              State Change ({summaryKeys.length})
            </th>
            <th className="border px-2 py-1">Count</th>
          </tr>
        </thead>
        <tbody className="bg-white font-mono text-gray-900">
          {summaryKeys.map((s) => {
            return (
              <tr key={s} className="border-b hover:bg-gray-100">
                <td className="border px-2 py-1">
                  {summary[s].from !== summary[s].to ? (
                    <span>
                      <span>{UNIT_STATE[summary[s].from]}</span>
                      {" => "}
                      <span>{UNIT_STATE[summary[s].to]}</span>
                    </span>
                  ) : (
                    <span>
                      Stay in <span>{UNIT_STATE[summary[s].from]}</span>
                    </span>
                  )}
                </td>
                <td
                  className="border cursor-pointer px-1 hover:font-bold"
                  onClick={() => props.handleFilterUnits(summary[s].unitIds)}
                >
                  {summary[s].unitIds.length}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

const UnitStateSummary = (props) => {
  const { items } = props;
  const itemsCountByState = _.countBy(items, "unit_state");

  return (
    itemsCountByState && (
      <table className="border shadow table w-full text-sm">
        <thead className="border-b bg-gray-200 text-xs text-blue-800">
          <tr>
            <th className="border px-2 py-1">Unit State</th>
            <th className="border px-2 py-1">Count</th>
          </tr>
        </thead>
        <tbody className="bg-white font-mono text-gray-900">
          {_.keys(UNIT_STATE).map((state) => {
            return (
              <tr key={state} className="border-b hover:bg-gray-100">
                <td className="border px-2 py-1">
                  {state}: {UNIT_STATE[state]}
                </td>
                <td className="border px-1 ">
                  {itemsCountByState[state] || 0}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    )
  );
};

const PendingActionsTable = (props) => {
  const {
    items,
    snapshotsByUnitId,
    selectedItems,
    handleSelectAll,
    handleSelectItem,
    handleCloseModal,
    handleOpenModal,
    isFixedPopup,
    networkInfo,
  } = props;

  const sortedItems = _sortItems(items);

  function _sortItems(items) {
    return _.orderBy(items, [_sort], ["desc"]);
  }

  function _sort(item) {
    return item.stat ? item.stat.raw_eligible_revenue_twd : -Infinity;
  }

  const hasNoExecutables = _.some(items, (item) => {
    return !item.actions || (item.actions && item.actions.conflicts.length > 0);
  });

  return (
    <div>
      <table
        className="border shadow table w-full text-sm"
        style={{ marginBottom: "500px" }}
      >
        <thead className="border-b bg-gray-200 text-xs text-blue-800">
          <tr>
            <th>
              {items.length > 0 && !hasNoExecutables && (
                <div className="w-12">
                  <VSECheckBox
                    isChecked={selectedItems.length === items.length}
                    handleClick={handleSelectAll}
                  ></VSECheckBox>
                </div>
              )}
            </th>
            {/* <th></th> */}
            <th className="border px-2 py-1">Unit</th>
            <th className="border px-2 py-1">raw_revenue_ratio</th>
            <th className="border px-2 py-1">Execution Plan</th>
            <th className="border px-2 py-1">Proposed by recipes</th>
            <th className="border px-2 py-1">Updated at</th>
          </tr>
        </thead>
        <tbody className="bg-white font-mono text-gray-900">
          {items &&
            sortedItems.map((r) => {
              return (
                <tr key={r.unit_id} className="border-b hover:bg-gray-100">
                  <td className="text-center">
                    {!hasNoExecutables && (
                      <VSECheckBox
                        isChecked={selectedItems.indexOf(r.unit_id) !== -1}
                        handleClick={() => handleSelectItem(r.unit_id)}
                      ></VSECheckBox>
                    )}
                  </td>
                  {/* <td>
                    <GoToInsightButton
                      unitId={r.unit_id}
                      qp="?tab=HEALTH_CHECK"
                      showIconOnly={true}
                    ></GoToInsightButton>
                  </td> */}
                  <td className="whitespace-no-wrap border px-2 py-1 font-sans font-semibold">
                    <div className="flex items-center justify-between gap-2">
                      <div>
                        <PopupWrapper
                          place="bottom left"
                          hideArrow={true}
                          isFixed={isFixedPopup}
                          triggerElement={
                            <button
                              type="button"
                              className="border-b border-gray-600"
                            >
                              {r.unit_id}{" "}
                              <span className="mr-1 text-gray-700">
                                {r.unit_name}
                              </span>
                              {r.isInsp && (
                                <span className="rounded bg-orange-400 px-2 text-xs font-bold text-orange-100">
                                  INSP
                                </span>
                              )}
                              {r.isDebug && (
                                <span className="rounded bg-pink-500 px-2 text-xs font-bold text-pink-100">
                                  DEBUG
                                </span>
                              )}
                              {r.hasGpt && (
                                <span className="rounded bg-indigo-100 px-2 text-xs text-gray-600">
                                  GPT
                                </span>
                              )}
                              {r.hasAmp && (
                                <span className="rounded bg-indigo-100 px-2 text-xs text-gray-600">
                                  AMP
                                </span>
                              )}
                            </button>
                          }
                          popupElement={
                            <div
                              className="overflow-y-auto border-4 border-gray-600 shadow-lg"
                              style={{ marginTop: "-9px", maxHeight: "500px" }}
                            >
                              {snapshotsByUnitId[r.unit_id] ? (
                                <AdUnitBasicCard
                                  networkId={networkInfo.gamNetworkId}
                                  networkName={networkInfo.name}
                                  unit={snapshotsByUnitId[r.unit_id]}
                                  showFullWidthCard={false}
                                  isCompactMode={false}
                                  handleCloseModal={handleCloseModal}
                                  handleOpenModal={handleOpenModal}
                                ></AdUnitBasicCard>
                              ) : (
                                <div>No snapshot</div>
                              )}
                            </div>
                          }
                        ></PopupWrapper>
                        <UnitMode unit={r}></UnitMode>
                      </div>
                      <div>
                        <UnitState state={r.unit_state}></UnitState>
                      </div>
                    </div>

                    <div className="text-xs font-normal text-gray-600">
                      {r.ysId} {r.ysName}
                    </div>
                  </td>
                  <td className="whitespace-no-wrap border px-3 py-1 text-left">
                    {r.stat && (
                      <div className="flex flex-row-reverse items-center justify-start gap-2">
                        <NumberFormat
                          value={r.stat["raw_revenue_ratio"]}
                          format="0,0.00%"
                        ></NumberFormat>
                        <div className="text-xs font-normal text-gray-600">
                          <NumberFormat
                            value={r.stat["raw_eligible_revenue_twd"]}
                            format="$0,0a"
                          ></NumberFormat>
                        </div>
                      </div>
                    )}
                  </td>
                  <td className="whitespace-no-wrap border px-3 py-1 text-left">
                    {r.actions ? (
                      <ul className="list-inside list-disc">
                        {r.actions.execution_plan.map((ep, i) => {
                          return (
                            <li key={i}>
                              <ActionPretty item={ep}></ActionPretty>
                            </li>
                          );
                        })}
                      </ul>
                    ) : (
                      "No actions"
                    )}
                    {r.actions &&
                      r.actions.conflicts &&
                      r.actions.conflicts.length > 0 && (
                        <div>
                          Conflicts:
                          <div>{JSON.stringify(r.actions.conflicts)}</div>
                        </div>
                      )}
                  </td>
                  <td className="whitespace-no-wrap border px-3 py-1 text-left">
                    {r.actions
                      ? r.actions.proposed_actions.map((action, i) => {
                          return (
                            <ActionRecipeBox
                              action={action}
                              key={i}
                            ></ActionRecipeBox>
                          );
                        })
                      : ""}
                  </td>
                  <td className="whitespace-no-wrap border px-3 py-1 text-right">
                    {r.updated_at}
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
    </div>
  );
};

const ActionFooter = (props) => {
  const { selectedItems, handleClearAll, handleExecuteClicked } = props;
  return (
    <div className="fixed bottom-0 left-0 w-full border-t-2 bg-white px-4 py-2">
      <div className="flex items-center gap-2 text-gray-700">
        <div className="w-48 text-right text-sm">
          Selected units ({selectedItems.length}):
        </div>
        <textarea
          rows="1"
          value={selectedItems.join(", ")}
          readOnly
          className="border rounded w-full p-1 text-xs"
        ></textarea>
        <div className="flex items-center gap-4">
          <button
            className="rounded overflow-x-auto bg-blue-200 px-2 py-1 text-sm font-semibold text-blue-900 hover:bg-blue-300"
            type="button"
            data-tip
            data-for="reset-recipes-button"
            onClick={handleExecuteClicked}
            disabled={selectedItems.length === 0}
          >
            Execute
          </button>
          <ReactTooltip id="reset-recipes-button" type="dark" effect="solid">
            See execute units in preview
          </ReactTooltip>
          <button
            className="rounded overflow-x-auto px-4 py-1 text-sm text-blue-600 hover:bg-blue-100"
            type="button"
            onClick={handleClearAll}
          >
            Clear
          </button>
        </div>
      </div>
    </div>
  );
};

const ActionRecipeBox = (props) => {
  const { action } = props;
  // version
  // preconditions
  // actions

  return (
    <>
      <PopupWrapper
        place="bottom left"
        hideArrow={true}
        triggerElement={
          <div className="rounded border cursor-pointer bg-gray-200 px-2">
            {action.recipe.id} - {action.recipe.name}
          </div>
        }
        popupElement={
          <div
            className="overflow-y-auto border-4 border-gray-600 shadow-lg"
            style={{ marginTop: "-9px", maxHeight: "500px" }}
          >
            <RecipeBox item={action.recipe}></RecipeBox>
          </div>
        }
      ></PopupWrapper>
    </>
  );
};

export default PendingActionsViewer;
